// single pages
import homePage from '../pages/home/index.vue'
import signUp from '../components/signUp/index.vue'
import signIn from '../components/signIn/index.vue'
import EnterOtp from '../components/EnterOtp/index.vue'
import ForgotPassword from '../components/ForgotPassword/index.vue'
import CreateNewPassword from '../components/CreateNewPassword/index.vue'
import PrivacyPolicy from '../components/PrivacyPolicy/index.vue'
import TermsAndCondition from '../components/TermsAndCondition/index.vue'
import Dashboard from '../pages/dasboard/index.vue'
import Calendar from '../pages/Calendar/index.vue'
import exploreProfessional from '../pages/exploreProfessional/index.vue'
import temporaryJobs from '../pages/temporaryJobs/index.vue'
import postJob from '../pages/postJob/index.vue'
import postTemporaryJob from '../pages/postTemporaryJob/index.vue'
import miniJob from '../pages/miniJob/index.vue'
import timeApprovalJobs from '../pages/timeApprovalJobs/index.vue'
import timeApprovalReports from '../pages/timeApprovalReports/index.vue'
import approvalJobs from '../pages/approvalJobs/index.vue'
import UserList from '../pages/UserList/index.vue'
import UserPermission from '../pages/UserPermission/index.vue'
import Profile from '../pages/profile/index.vue'
import openJobs from '../pages/openJobs/index.vue'
import openJobsReports from '../pages/openJobsReports/index.vue'
import upcomingJobs from '../pages/upcomingJobs/index.vue'
import upcomingJobsReports from '../pages/upcomingJobsReports/index.vue'
import ongoingJobs from '../pages/ongoingJobs/index.vue'
import ongoingJobsReports from '../pages/ongoingJobsReports/index.vue'
import completedJobs from '../pages/completedJobs/index.vue'
import completedJobsReports from '../pages/completedJobsReports/index.vue'
import cancelledJobs from '../pages/cancelledJobs/index.vue'
import cancelledJobsReports from '../pages/cancelledJobsReports/index.vue'
import allJobs from '../pages/allJobs/index.vue'
import OrganizationProfile from '../pages/OrganizationProfile/index.vue'
import Companies from '../pages/Companies/index.vue'
import CompaniesList from '../pages/CompaniesList/index.vue'
import Branch from '../pages/Branch/index.vue'
import BranchList from '../pages/BranchList/index.vue'
import CompaniesStatus from '../pages/CompaniesStatus/index.vue'
import BranchStatus from '../pages/BranchStatus/index.vue'
import BranchSetupYourMaster from '../pages/BranchSetupYourMaster/index.vue'
import BranchSetupTest from '../pages/BranchSetupTest/index.vue'
import AddCompany from '../pages/AddCompany/index.vue'
import loginWithOtp from '../components/loginWithOtp/index.vue'

import { routePropResolver } from './util'
import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {
    path: '/',
    name: 'home',
    component: homePage,
    meta: { title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/sign_up',
    name: 'signUp',
    component: signUp,
    meta: { title: `${DOMAIN_TITLE} | sign_up` }
  },
  {
    path: '/sign_in',
    name: 'signIn',
    component: signIn,
    meta: { title: `${DOMAIN_TITLE} | sign_in` }
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { title: `${DOMAIN_TITLE} | forgot_password` },
    props: routePropResolver
  },
  {
    path: '/enter_otp',
    name: 'EnterOtp',
    component: EnterOtp,
    meta: { title: `${DOMAIN_TITLE} | enter_otp` },
    props: routePropResolver
  },
  {
    path: '/create_new_password',
    name: 'CreateNewPassword',
    component: CreateNewPassword,
    meta: { title: `${DOMAIN_TITLE} | create_new_password` },
    props: routePropResolver
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { title: `${DOMAIN_TITLE} | privacy-policy` },
    props: routePropResolver
  },
  {
    path: '/terms-and-condition',
    name: 'TermsAndCondition',
    component: TermsAndCondition,
    meta: { title: `${DOMAIN_TITLE} | terms-and-condition` },
    props: routePropResolver
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: `${DOMAIN_TITLE} | dashboard`, auth: true },
    props: routePropResolver
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: { title: `${DOMAIN_TITLE} | calendar`, auth: true },
    props: routePropResolver
  },
  {
    path: '/explore_Professional',
    name: 'exploreProfessional',
    component: exploreProfessional,
    meta: { title: `${DOMAIN_TITLE} | explore_Professional`, auth: true }
  },
  {
    path: '/temporary_jobs',
    name: 'temporaryJobs',
    component: temporaryJobs,
    meta: { title: `${DOMAIN_TITLE} | temporary_jobs`, auth: true }
  },
  {
    path: '/post_job',
    name: 'postJob',
    component: postJob,
    meta: { title: `${DOMAIN_TITLE} | post_job`, auth: true }
  },
  {
    path: '/post_temporary_job',
    name: 'postTemporaryJob',
    component: postTemporaryJob,
    meta: { title: `${DOMAIN_TITLE} | post_job`, auth: true }
  },
  {
    path: '/mini_job',
    name: 'miniJob',
    component: miniJob,
    meta: { title: `${DOMAIN_TITLE} | mini_job`, auth: true }
  },
  {
    path: '/time_approval_jobs',
    name: 'timeApprovalJobs',
    component: timeApprovalJobs,
    meta: { title: `${DOMAIN_TITLE} | time_approval_jobs`, auth: true }
  },
  {
    path: '/time_approval_reports',
    name: 'timeApprovalreports',
    component: timeApprovalReports,
    meta: { title: `${DOMAIN_TITLE} | time_approval_Reports`, auth: true }
  },
  {
    path: '/approval_jobs',
    name: 'approvalJobs',
    component: approvalJobs,
    meta: { title: `${DOMAIN_TITLE} | approval_jobs`, auth: true }
  },
  {
    path: '/open_jobs',
    name: 'openJobs',
    component: openJobs,
    meta: { title: `${DOMAIN_TITLE} | open_jobs`, auth: true }
  },
  {
    path: '/open_jobs_report',
    name: 'openJobsReports',
    component: openJobsReports,
    meta: { title: `${DOMAIN_TITLE} | open_jobs_report`, auth: true }
  },
  {
    path: '/upcoming_jobs',
    name: 'upcomingJobs',
    component: upcomingJobs,
    meta: { title: `${DOMAIN_TITLE} | upcoming_jobs`, auth: true }
  },
  {
    path: '/upcoming_jobs_report',
    name: 'upcomingJobsReports',
    component: upcomingJobsReports,
    meta: { title: `${DOMAIN_TITLE} | upcoming_jobs_report`, auth: true }
  },
  {
    path: '/ongoing_jobs',
    name: 'ongoingJobs',
    component: ongoingJobs,
    meta: { title: `${DOMAIN_TITLE} | ongoing_jobs`, auth: true }
  },
  {
    path: '/ongoing_jobs_report',
    name: 'ongoingJobsReports',
    component: ongoingJobsReports,
    meta: { title: `${DOMAIN_TITLE} | ongoing_jobs_report`, auth: true }
  },
  {
    path: '/completed_jobs',
    name: 'completedJobs',
    component: completedJobs,
    meta: { title: `${DOMAIN_TITLE} | completed_jobs`, auth: true }
  },
  {
    path: '/completed_jobs_report',
    name: 'completedJobsReports',
    component: completedJobsReports,
    meta: { title: `${DOMAIN_TITLE} | completed_jobs_report`, auth: true }
  },
  {
    path: '/cancelled_jobs',
    name: 'cancelledJobs',
    component: cancelledJobs,
    meta: { title: `${DOMAIN_TITLE} | cancelled_jobs`, auth: true }
  },
  {
    path: '/cancelled_jobs_report',
    name: 'cancelledJobsReports',
    component: cancelledJobsReports,
    meta: { title: `${DOMAIN_TITLE} | cancelled_jobs_report`, auth: true }
  },
  {
    path: '/all_jobs',
    name: 'allJobs',
    component: allJobs,
    meta: { title: `${DOMAIN_TITLE} | all_jobs`, auth: true }
  },
  {
    path: '/user/user_list',
    name: 'UserList',
    component: UserList,
    meta: { title: `${DOMAIN_TITLE} | user_list`, auth: true }
  },
  {
    path: '/user/user_permission',
    name: 'UserPermission',
    component: UserPermission,
    meta: { title: `${DOMAIN_TITLE} | user_permission`, auth: true }
  },
  {
    path: '/setting/profile',
    name: 'profile',
    component: Profile,
    meta: { title: `${DOMAIN_TITLE} | profile`, auth: true }
  },
  {
    path: '/setting/organization_profile',
    name: 'OrganizationProfile',
    component: OrganizationProfile,
    meta: { title: `${DOMAIN_TITLE} | organization_profile`, auth: true }
  },
  {
    path: '/setting/companies',
    name: 'Companies',
    component: Companies,
    meta: { title: `${DOMAIN_TITLE} | companies`, auth: true }
  },
  {
    path: '/companies/companies_list',
    name: 'CompaniesList',
    component: CompaniesList,
    meta: { title: `${DOMAIN_TITLE} | companies_list`, auth: true }
  },
  {
    path: '/branch/branch_list',
    name: 'BranchList',
    component: BranchList,
    meta: { title: `${DOMAIN_TITLE} | branch_list`, auth: true }
  },
  {
    path: '/setting/branch',
    name: 'Branch',
    component: Branch,
    meta: { title: `${DOMAIN_TITLE} | branch`, auth: true }
  },
  {
    path: '/companies_status',
    name: 'CompaniesStatus',
    component: CompaniesStatus,
    meta: { title: `${DOMAIN_TITLE} | branch`, auth: true }
  },
  {
    path: '/branch_status',
    name: 'BranchStatus',
    component: BranchStatus,
    meta: { title: `${DOMAIN_TITLE} | branch_status`, auth: true }
  },
  {
    path: '/branch_status/setup_your_master',
    name: 'BranchSetupYourMaster',
    component: BranchSetupYourMaster,
    meta: { title: `${DOMAIN_TITLE} | setup_your_master`, auth: true }
  },
  {
    path: '/branch_status/branch_setup_test',
    name: 'BranchSetupTest',
    component: BranchSetupTest,
    meta: { title: `${DOMAIN_TITLE} | setup_your_master`, auth: true }
  },
  {
    path: '/companies/add_company',
    name: 'AddCompany',
    component: AddCompany,
    meta: { title: `${DOMAIN_TITLE} | setup_your_master`, auth: true }
  },
  {
    path: '/login_with_otp',
    name: 'loginWithOtp',
    component: loginWithOtp,
    meta: { title: `${DOMAIN_TITLE} | login_with_otp` }
  }
]
